import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { UploadLinkFields } from '../../fragments/generated/UploadLinkFields';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateUploadLinkMutationVariables = Types.Exact<{
  input: Types.CreateUploadLinkInput;
}>;


export type CreateUploadLinkMutation = { __typename?: 'Mutation', createUploadLink?: { __typename?: 'UploadLinkPayload', uploadLink?: { __typename?: 'UploadLink', hasPassphrase?: boolean | null, expiresIn?: number | null, id?: string | null, name?: string | null, url?: string | null, enabled?: boolean | null, passphrase?: string | null, expiresAt?: string | null, insertedAt?: string | null, updatedAt?: string | null, creator?: { __typename?: 'AuthenticatedUser', id: string, name?: string | null, profileImageUrl?: string | null } | null, folder?: { __typename?: 'FolderAsset', id: string, name: string, restricted?: boolean | null } | null, project?: { __typename?: 'Project', id: string, name: string } | null } | null } | null };


export const CreateUploadLink = /*#__PURE__*/ gql`
    mutation CreateUploadLink($input: CreateUploadLinkInput!) @stewardship(stewards: [VIEWER]) {
  createUploadLink(input: $input) {
    uploadLink {
      ...UploadLinkFields
      hasPassphrase
      expiresIn
    }
  }
}
    ${UploadLinkFields}` as unknown as DocumentNode<CreateUploadLinkMutation, CreateUploadLinkMutationVariables>;

          

          export const useCreateUploadLinkMutation = (options?:MutationHookOptions<CreateUploadLinkMutation, CreateUploadLinkMutationVariables>) => useMutation(CreateUploadLink, options);
          

          export type CreateUploadLinkMutationOptions = MutationHookOptions<CreateUploadLinkMutation, CreateUploadLinkMutationVariables>;

          

          export type CreateUploadLinkMutationResult = ReturnType<typeof useCreateUploadLinkMutation>[1];

          
